var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("circle", {
        staticClass: "st0",
        attrs: { cx: "45", cy: "92.7", r: "7.2" },
      }),
      _vm._v(" "),
      _c("circle", {
        staticClass: "st0",
        attrs: { cx: "90.8", cy: "92.7", r: "7.2" },
      }),
      _vm._v(" "),
      _c("polyline", {
        staticClass: "st0",
        attrs: {
          points:
            "95.197,40.3 109.8,40.3 97,78.3 42.7,78.3 44.4,85.5 27.9,15.2 11.9,15.2 ",
        },
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "st0",
        attrs: { x1: "44.8", y1: "40.3", x2: "53.029", y2: "40.3" },
      }),
      _vm._v(" "),
      _c("path", { staticClass: "st0", attrs: { d: "M90.8,85.5" } }),
      _vm._v(" "),
      _c("line", {
        staticClass: "st0",
        attrs: { x1: "44.4", y1: "85.5", x2: "90.8", y2: "85.5" },
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "st0",
        attrs: { x1: "49.76", y1: "53.795", x2: "92.75", y2: "53.795" },
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "st0",
        attrs: { x1: "53.78", y1: "66.087", x2: "88.382", y2: "66.087" },
      }),
      _vm._v(" "),
      _c("polyline", {
        staticClass: "st0",
        attrs: {
          points:
            "61.698,31.9 74.498,45.6 87.298,31.9 74.698,45.6 74.698,14.2 ",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }